import React from 'react'
import { Link } from 'react-router-dom'
import Tooltip from '../../../ToolTip';

type Props = {
  to: string;
  children: React.ReactNode;
  className?: string
  showTooltip?: boolean
  toolTipMessage?: string
  tooltipDisabled?: boolean
}

const RouteLink: React.FC<Props> = ({ to, children, className, showTooltip = false, toolTipMessage, tooltipDisabled = false }) => {
  return (
    <>    {
      showTooltip ?
        <Tooltip message={toolTipMessage} disabled={tooltipDisabled}>
          <Link to={to} className={`hover:underline text-link-main dark:text-darkBg-textLink dark:hover:text-darkBg-textLink ${className}`}> <div className='truncate text-ellipsis max-w-[250px]'>{children}</div></Link>
        </Tooltip> :
        <Link to={to} className={`hover:underline text-link-main dark:text-darkBg-textLink dark:hover:text-darkBg-textLink ${className}`}> <div className='truncate text-ellipsis max-w-[250px]'>{children}</div></Link>
    }</>

  )
}

export default RouteLink